import { getCurrentUser } from "controller/getCurrentUser"

export function useCurrentUser() {
    return getCurrentUser.useResults() ?? {}
}
